import {DeserializedRecord, deserializeItem, Deserializer, deserializeSingleRelationship, JSONAPIRecord, JSONAPISingleRelationship} from "../Helpers";
import {MediumResourceConnection} from "./resource/MediumResourceConnection";

interface MediumResource extends DeserializedRecord {
  type: 'medium_external_resource'
  name: string,
  externalIdentifier: string
  mediumExternalResourceConnection: MediumResourceConnection
}

interface MediumResourceData extends JSONAPIRecord {
  relationships: {
    medium_external_resource_connection: JSONAPISingleRelationship
  }
}

const deserializeMediumExternalResource: Deserializer<MediumResource, MediumResourceData> = (data, included) => {
  const mediumExternalResourceConnection = deserializeSingleRelationship<MediumResourceConnection>(
    data.relationships.medium_external_resource_connection,
    included
  );

  return {
    ...deserializeItem<MediumResource>(data),
    mediumExternalResourceConnection
  };
};

export {
  MediumResource, deserializeMediumExternalResource
};
